import { baseApi } from "../app-main/store/baseApi";

export type MessagesSearchFilter = "requests" | "inquiries";
export type MessagesSearchBookingState = "ACTIVE" | "GUEST_UPDATE_REQUESTED";

export type MessagesSearchRequest = {
  booking_state?: MessagesSearchBookingState[];
  booking_starts_at_from?: string;
  booking_starts_at_to?: string;
  filters?: MessagesSearchFilter[];
  participant_ssoid?: string;
  size?: number;
  from?: number;
};

export type SearchMessagesArgs = MessagesSearchRequest;

export type MessagesSearchParticipant = {
  ssoid: string;
  name: { first: string; last: string };
  avatar_id?: string;
  avatar_url?: string;
};

export type MessagesSearchListing = {
  title: string;
  use_type: string;
  venue_name: string | null;
  thumbnail: { url: string; url_small: string };
};

export type MessagesSearchBooking = {
  id: string;
  state: string;
  contract_id: string;
  contract_state: string;
  ends_at?: string;
  starts_at: string;
  expires_at: string;
};

// The "outer" thread item in the search response. Confusingly the backend
// nests another `thread` object on it (containing the booking, messages,
// etc) — we keep the same shape here on purpose.
export type MessagesSearchThreadInner = {
  id: string;
  state: string;
  contract_id: string;
  contract_state: string;
  starts_at: string;
  expires_at: string;
  listing_id: string;
  space_id: string;
  stream_channel_id: string;
  created_at: string;
  unread_by: string[];
  booking: MessagesSearchBooking;
};

export type MessagesSearchThread = {
  id: string;
  score: number | null;
  inner_hits: null;
  listing: MessagesSearchListing;
  participants: MessagesSearchParticipant[];
  thread: MessagesSearchThreadInner;
};

export type MessagesSearchResponse = {
  threads: MessagesSearchThread[];
  total: number;
  from: number;
  size: number;
};

export type UnreadMessageCountResponse = {
  thread_count: number;
};

export const messagesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    searchMessages: builder.query<MessagesSearchResponse, SearchMessagesArgs>({
      query: ({ size = 1, from = 0, ...body }) => ({
        url: "/v2/messaging/messages/search",
        method: "POST",
        body: {
          ...body,
          size,
          from,
        },
      }),
    }),

    getUnreadMessageCount: builder.query<UnreadMessageCountResponse, void>({
      query: () => ({
        url: "/v2/messaging/messages/inbox/unread-count",
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetUnreadMessageCountQuery,
  useSearchMessagesQuery,
} = messagesApi;
